import { render, staticRenderFns } from "./NewDepartment.vue?vue&type=template&id=d467eb0e&"
import script from "./NewDepartment.vue?vue&type=script&lang=js&"
export * from "./NewDepartment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports